// next/lib/privateRoomConfig.js

export const minBookingGuests =
    Number(
        process.env
            .NEXT_PUBLIC_PRIVATE_ROOM_MIN_BOOKING_GUESTS
    );

export const maxBookingGuests =
    Number(
        process.env
            .NEXT_PUBLIC_PRIVATE_ROOM_MAX_BOOKING_GUESTS
    ) || 50;